export const gapMap = {
  0: { class: "gap-0", cssValue: "0" },
  0.5: { class: "gap-1", cssValue: "0.25rem" },
  1: { class: "gap-2", cssValue: "0.5rem" },
  2: { class: "gap-4", cssValue: "1rem" },
  3: { class: "gap-6", cssValue: "1.5rem" },
  4: { class: "gap-8", cssValue: "2rem" },
};

export const gapMdMap = {
  0: { class: "md:gap-0", cssValue: "0" },
  0.5: { class: "md:gap-1", cssValue: "0.25rem" },
  1: { class: "md:gap-2", cssValue: "0.5rem" },
  2: { class: "md:gap-4", cssValue: "1rem" },
  3: { class: "md:gap-6", cssValue: "1.5rem" },
  4: { class: "md:gap-8", cssValue: "2rem" },
};

export const gapXlMap = {
  0: { class: "xl:gap-0", cssValue: "0" },
  0.5: { class: "xl:gap-1", cssValue: "0.25rem" },
  1: { class: "xl:gap-2", cssValue: "0.5rem" },
  2: { class: "xl:gap-4", cssValue: "1rem" },
  3: { class: "xl:gap-6", cssValue: "1.5rem" },
  4: { class: "xl:gap-8", cssValue: "2rem" },
  5: { class: "xl:gap-10", cssValue: "2.5rem" },
  6: { class: "xl:gap-12", cssValue: "3rem" },
  7: { class: "xl:gap-14", cssValue: "3.5rem" },
  8: { class: "xl:gap-16", cssValue: "4rem" },
};

export const justifyMap = {
  start: { class: "justify-start", cssValue: "flex-start" },
  center: { class: "justify-center", cssValue: "center" },
  end: { class: "justify-end", cssValue: "flex-end" },
  spaceAround: { class: "justify-around", cssValue: "space-around" },
  spaceBetween: { class: "justify-between", cssValue: "space-between" },
  spaceEvenly: { class: "justify-evenly", cssValue: "space-evenly" },
  stretch: { class: "justify-stretch", cssValue: "stretch" },
};

export const textAlignmentMap = {
  left: { class: "text-left", cssValue: "left" },
  right: { class: "text-right", cssValue: "right" },
  center: { class: "text-center", cssValue: "center" },
  justify: { class: "text-justify", cssValue: "justify" },
};

export const lineClampMap = {
  1: { class: "line-clamp-1", cssValue: "1" },
  2: { class: "line-clamp-2", cssValue: "2" },
  3: { class: "line-clamp-3", cssValue: "3" },
  4: { class: "line-clamp-4", cssValue: "4" },
};

export const maxCharsWidthMap = {
  10: { class: "max-w-[10ch]", cssValue: "10ch" },
  20: { class: "max-w-[20ch]", cssValue: "20ch" },
  30: { class: "max-w-[30ch]", cssValue: "30ch" },
  40: { class: "max-w-[40ch]", cssValue: "40ch" },
};

export const textColorMap = {
  primary: { class: "text-white", cssValue: "#FFFFFF" },
  secondary: { class: "text-stg-grey-4", cssValue: "#b6b6b6" },

  tertiary: { class: "text-stg-highlight", cssValue: "#ea9e04" },
  error: { class: "text-stg-red-3", cssValue: "#E10D37" },
  black: { class: "text-black", cssValue: "#000000" },
};

export const textSizeMap = {
  1: { class: "text-xss", cssValue: "0.625rem" },
  2: { class: "text-xs", cssValue: "0.75rem" },
  3: { class: "text-sm", cssValue: "0.875rem" },
  4: { class: "text-base", cssValue: "1rem" },
  5: { class: "text-lg", cssValue: "1.125rem" },
  5.5: { class: "text-2xl", cssValue: "1.5rem" },
  6: { class: "text-3.25xl", cssValue: "2rem" },
};

export const textSizeMdMap = {
  1: { class: "md:text-xss", cssValue: "0.625rem" },
  2: { class: "md:text-xs", cssValue: "0.75rem" },
  3: { class: "md:text-sm", cssValue: "0.875rem" },
  4: { class: "md:text-base", cssValue: "1rem" },
  5: { class: "md:text-lg", cssValue: "1.125rem" },
  6: { class: "md:text-3.25xl", cssValue: "2rem" },
  // Desktop-only font size (2.5rem) as specified in the new Design System
  7: { class: "md:text-4.25xl", cssValue: "2.5rem" },
  8: { class: "md:text-5xl", cssValue: "3rem" },
};

export const textWeightMap = {
  light: { class: "font-light", cssValue: "300" },
  regular: { class: "font-normal", cssValue: "400" },
  medium: { class: "font-medium", cssValue: "500" },
  bold: { class: "font-bold", cssValue: "700" },
};

export const alignMap = {
  start: { class: "items-start", cssValue: "flex-start" },
  center: { class: "items-center", cssValue: "center" },
  end: { class: "items-end", cssValue: "flex-end" },
  stretch: { class: "items-stretch", cssValue: "stretch" },
  baseline: { class: "items-baseline", cssValue: "baseline" },
};

//  ------- Box Scale -------

export const paddingMap = {
  0: { class: "p-0", cssValue: "0" },
  1: { class: "p-1", cssValue: "0.25rem" },
  2: { class: "p-2", cssValue: "0.5rem" },
  2.5: { class: "p-[0.625rem]", cssValue: "0.625rem" },
  3: { class: "p-3", cssValue: "0.75rem" },
  4: { class: "p-4", cssValue: "1rem" },
  5: { class: "p-5", cssValue: "1.25rem" },
  6: { class: "p-6", cssValue: "1.5rem" },
  7: { class: "p-7", cssValue: "1.75rem" },
  8: { class: "p-8", cssValue: "2rem" },
  9: { class: "p-9", cssValue: "2.25rem" },
  10: { class: "p-10", cssValue: "2.5rem" },
  11: { class: "p-11", cssValue: "2.75rem" },
  12: { class: "p-12", cssValue: "3rem" },
};

export const paddingTopMap = {
  0: { class: "pt-0", cssValue: "0" },
  1: { class: "pt-1", cssValue: "0.25rem" },
  2: { class: "pt-2", cssValue: "0.5rem" },
  2.5: { class: "pt-[0.625rem]", cssValue: "0.625rem" },
  3: { class: "pt-3", cssValue: "0.75rem" },
  4: { class: "pt-4", cssValue: "1rem" },
  5: { class: "pt-5", cssValue: "1.25rem" },
  6: { class: "pt-6", cssValue: "1.5rem" },
  7: { class: "pt-7", cssValue: "1.75rem" },
  8: { class: "pt-8", cssValue: "2rem" },
  9: { class: "pt-9", cssValue: "2.25rem" },
  10: { class: "pt-10", cssValue: "2.5rem" },
  11: { class: "pt-11", cssValue: "2.75rem" },
  12: { class: "pt-12", cssValue: "3rem" },
};

export const paddingBottomMap = {
  0: { class: "pb-0", cssValue: "0" },
  1: { class: "pb-1", cssValue: "0.25rem" },
  2: { class: "pb-2", cssValue: "0.5rem" },
  2.5: { class: "pb-[0.625rem]", cssValue: "0.625rem" },
  3: { class: "pb-3", cssValue: "0.75rem" },
  4: { class: "pb-4", cssValue: "1rem" },
  5: { class: "pb-5", cssValue: "1.25rem" },
  6: { class: "pb-6", cssValue: "1.5rem" },
  7: { class: "pb-7", cssValue: "1.75rem" },
  8: { class: "pb-8", cssValue: "2rem" },
  9: { class: "pb-9", cssValue: "2.25rem" },
  10: { class: "pb-10", cssValue: "2.5rem" },
  11: { class: "pb-11", cssValue: "2.75rem" },
  12: { class: "pb-12", cssValue: "3rem" },
};

export const paddingLeftMap = {
  0: { class: "pl-0", cssValue: "0" },
  1: { class: "pl-1", cssValue: "0.25rem" },
  2: { class: "pl-2", cssValue: "0.5rem" },
  2.5: { class: "pl-[0.625rem]", cssValue: "0.625rem" },
  3: { class: "pl-3", cssValue: "0.75rem" },
  4: { class: "pl-4", cssValue: "1rem" },
  5: { class: "pl-5", cssValue: "1.25rem" },
  6: { class: "pl-6", cssValue: "1.5rem" },
  7: { class: "pl-7", cssValue: "1.75rem" },
  8: { class: "pl-8", cssValue: "2rem" },
  9: { class: "pl-9", cssValue: "2.25rem" },
  10: { class: "pl-10", cssValue: "2.5rem" },
  11: { class: "pl-11", cssValue: "2.75rem" },
  12: { class: "pl-12", cssValue: "3rem" },
};

export const paddingRightMap = {
  0: { class: "pr-0", cssValue: "0" },
  1: { class: "pr-1", cssValue: "0.25rem" },
  2: { class: "pr-2", cssValue: "0.5rem" },
  2.5: { class: "pr-[0.625rem]", cssValue: "0.625rem" },
  3: { class: "pr-3", cssValue: "0.75rem" },
  4: { class: "pr-4", cssValue: "1rem" },
  5: { class: "pr-5", cssValue: "1.25rem" },
  6: { class: "pr-6", cssValue: "1.5rem" },
  7: { class: "pr-7", cssValue: "1.75rem" },
  8: { class: "pr-8", cssValue: "2rem" },
  9: { class: "pr-9", cssValue: "2.25rem" },
  10: { class: "pr-10", cssValue: "2.5rem" },
  11: { class: "pr-11", cssValue: "2.75rem" },
  12: { class: "pr-12", cssValue: "3rem" },
};

export const paddingHorizontalMap = {
  0: { class: "px-0", cssValue: "0" },
  1: { class: "px-1", cssValue: "0.25rem" },
  2: { class: "px-2", cssValue: "0.5rem" },
  2.5: { class: "px-[0.625rem]", cssValue: "0.625rem" },
  3: { class: "px-3", cssValue: "0.75rem" },
  4: { class: "px-4", cssValue: "1rem" },
  5: { class: "px-5", cssValue: "1.25rem" },
  6: { class: "px-6", cssValue: "1.5rem" },
  7: { class: "px-7", cssValue: "1.75rem" },
  8: { class: "px-8", cssValue: "2rem" },
  9: { class: "px-9", cssValue: "2.25rem" },
  10: { class: "px-10", cssValue: "2.5rem" },
  11: { class: "px-11", cssValue: "2.75rem" },
  12: { class: "px-12", cssValue: "3rem" },
};

export const paddingVerticalMap = {
  0: { class: "py-0", cssValue: "0" },
  1: { class: "py-1", cssValue: "0.25rem" },
  2: { class: "py-2", cssValue: "0.5rem" },
  2.5: { class: "py-[0.625rem]", cssValue: "0.625rem" },
  3: { class: "py-3", cssValue: "0.75rem" },
  4: { class: "py-4", cssValue: "1rem" },
  5: { class: "py-5", cssValue: "1.25rem" },
  6: { class: "py-6", cssValue: "1.5rem" },
  7: { class: "py-7", cssValue: "1.75rem" },
  8: { class: "py-8", cssValue: "2rem" },
  9: { class: "py-9", cssValue: "2.25rem" },
  10: { class: "py-10", cssValue: "2.5rem" },
  11: { class: "py-11", cssValue: "2.75rem" },
  12: { class: "py-12", cssValue: "3rem" },
};

export const positionMap = {
  static: { class: "static", cssValue: "static" },
  relative: { class: "relative", cssValue: "relative" },
  absolute: { class: "absolute", cssValue: "absolute" },
  fixed: { class: "fixed", cssValue: "fixed" },
  sticky: { class: "sticky", cssValue: "sticky" },
};

export const aspectRatioMap = {
  video: { class: "aspect-video", cssValue: "16 / 9" },
  square: { class: "aspect-square", cssValue: "1 / 1" },
};
export const overflowMap = {
  hidden: { class: "overflow-hidden", cssValue: "hidden" },
  auto: { class: "overflow-auto", cssValue: "auto" },
  visible: { class: "overflow-visible", cssValue: "visible" },
  scroll: { class: "overflow-scroll", cssValue: "scroll" },
  clip: { class: "overflow-clip", cssValue: "clip" },
};

export const overflowXMap = {
  auto: { class: "overflow-x-auto", cssValue: "auto" },
  hidden: { class: "overflow-x-hidden", cssValue: "hidden" },
  visible: { class: "overflow-x-visible", cssValue: "visible" },
  scroll: { class: "overflow-x-scroll", cssValue: "scroll" },
  clip: { class: "overflow-x-clip", cssValue: "clip" },
};

export const overflowYMap = {
  auto: { class: "overflow-y-auto", cssValue: "auto" },
  hidden: { class: "overflow-y-hidden", cssValue: "hidden" },
  visible: { class: "overflow-y-visible", cssValue: "visible" },
  scroll: { class: "overflow-y-scroll", cssValue: "scroll" },
  clip: { class: "overflow-y-clip", cssValue: "clip" },
};

export const borderRadiusMap = {
  0: { class: "rounded-0", cssValue: "0" },
  1: { class: "rounded-md", cssValue: "0.375rem" },
  2: { class: "rounded-lg", cssValue: "0.5rem" },
  3: { class: "rounded-xl", cssValue: "0.75rem" },
  4: { class: "rounded-2xl", cssValue: "1rem" },
  5: { class: "rounded-3xl", cssValue: "1.5rem" },
  full: { class: "rounded-full", cssValue: "9999px" },
};

export const borderWidthMap = {
  1: { class: "border", cssValue: "1px" },
  2: { class: "border-2", cssValue: "2px" },
  3: { class: "border-[3px]", cssValue: "3px" },
  4: { class: "border-4", cssValue: "4px" },
};

export const borderColorMap = {
  primary: { class: "border-[--grey-3]", cssValue: "#464646" },
  secondary: { class: "border-white", cssValue: "#FFFFFF" },
  tertiary: { class: "border-[--primary-cta]", cssValue: "#248b3b" },
  // new design system: wip
  newPrimary: { class: "border-stg-grey-3", cssValue: "#464646" },
  newTertiary: { class: "border-stg-green", cssValue: "#258D58" },
};

export const backgroundMap = {
  primary: { class: "bg-stg-secondary-cta", cssValue: "#292929" },
  secondary: { class: "bg-stg-grey-2", cssValue: "#313131" },
  yellow25: { class: "bg-stg-highlight-25", cssValue: "#EA9E0440" },
  // new design system: wip
  newPrimary: { class: "bg-stg-grey-1", cssValue: "#1A1A1A" },
  newSecondary: { class: "bg-stg-grey-2", cssValue: "#313131" },
};
